import { render, staticRenderFns } from "./MeasurementPointTrendDialog.vue?vue&type=template&id=bf8ca42e&scoped=true"
import script from "./MeasurementPointTrendDialog.vue?vue&type=script&lang=js"
export * from "./MeasurementPointTrendDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf8ca42e",
  null
  
)

export default component.exports